import styled from 'styled-components';
import { Button } from '@blueprintjs/core';
export const StrokedButton = styled(Button) `
  :not([disabled]) {
    color: var(--main-green-1) !important;
    border: 1px var(--main-green-1) solid;
    background-color: transparent !important;
  }
  background-image: unset !important;
  box-shadow: unset !important;
  :hover:not([disabled]) {
    color: white !important;
    background-color: var(--main-green-1) !important;
  }
`;
export const SolidButton = styled.button `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  box-sizing: border-box;
  padding: 10px 20px;
  cursor: pointer;
  border: 0;
  border-radius: 5px;

  font-family: 'Montserrat';
  font-weight: 600;

  background: var(--main-green-1);
  color: white;

  transition: max-height 0.5s ease-in-out 0.5s, background-color 0.5s;

  :hover {
    background: var(--main-green-6);
  }

  :focus {
    position: relative;
    outline: 1px solid var(--main-green-1);
    outline-offset: 4px;
  }

  :disabled {
    background-color: var(--main-grey-2);
    pointer-events: none;
  }
`;
//# sourceMappingURL=Buttons.js.map